"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

// Header
// ======
//
// As in not the main header at the top of the page. Heading should be a h1,
// subheading = h2. Otherwise, supply custom-styled child elements.
var Header = function Header(_ref) {
  var image = _ref.image,
      _ref$imageAlt = _ref.imageAlt,
      imageAlt = _ref$imageAlt === void 0 ? 'heading' : _ref$imageAlt,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("header", {
    className: (0, _classnames.default)(_indexModule.default.Header, _indexModule.default[align])
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: imageAlt,
    className: _indexModule.default.image
  }), children);
};

Header.propTypes = {
  image: _propTypes.default.string,
  imageAlt: _propTypes.default.string,
  align: _propTypes.default.oneOf(['left', 'center', 'right'])
};
var _default = Header;
exports.default = _default;